import Form from '~~/classes/Form';

export default function <Fields>(fields: Fields, onUpdateCallback: Function | null = null) {
    const form = new Form(fields, onUpdateCallback);
    return reactive(form);
}
